module.exports = __webpack_public_path__ + "static/img/download_left.6b826629.png";